import { Pipe, PipeTransform } from '@angular/core';
import { IPricePerRoomPrice } from "./price-per-room-mapping.service";

@Pipe({
    name: 'findRoom'
})

export class FindRoomPipe implements PipeTransform {
    public transform(roomId: string, rooms: IPricePerRoomPrice[]): IPricePerRoomPrice {
        return rooms.find((room: IPricePerRoomPrice) => room.roomId === roomId);
    }
}